/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/8/28
 * Time: 下午5:53
 */
import { getCurCursorPosition, markdownLock } from '../../../mixin/docs'

function _handleMarkdown (quill, titleNumber) {
  markdownLock(true)
  console.log('匹配到了标题' + titleNumber)
  const selectIndex = getCurCursorPosition(quill)
  const delNum = titleNumber + 1
  if (selectIndex !== null) {
    quill.deleteText(selectIndex - delNum, delNum)
    quill.format('header', titleNumber)
  }
  markdownLock(false)
}

export default {
  type: 'title', // 类型，这里为标题
  regexObj: null, // 如果有option的话就是null，没有的话就是正则表达式对象
  styleAttributes: null,
  options: [
    {
      type: 'h1', // 名称
      regexObj: /^(?:# ([^\r\n]*))/gm, // 正则表达式对象
      styleAttributes: {
        header: 1
      },
      handleMarkdown: (quill) => _handleMarkdown(quill, 1)
    },
    {
      type: 'h2',
      regexObj: /^(?:## ([^\r\n]*))/gm,
      styleAttributes: {
        header: 2
      },
      handleMarkdown: (quill) => _handleMarkdown(quill, 2)
    },
    {
      type: 'h3',
      regexObj: /^(?:### ([^\r\n]*))/gm,
      styleAttributes: {
        header: 3
      },
      handleMarkdown: (quill) => _handleMarkdown(quill, 3)
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/quill/markdown/title.js